export default function LogoCard({ image, name, height = "h-14 md:h-16" }) {
    return (
        <div className="group bg-white rounded-card-md border border-line px-4 py-3 shadow-sm hover:shadow-md hover:-translate-y-1 hover:border-primary/40 transition-all duration-300">
            <div className={`flex items-center justify-center ${height}`}>
                <img
                    src={image}
                    alt={name}
                    loading="lazy"
                    className="max-w-full max-h-full object-contain grayscale-0 opacity-90 group-hover:opacity-100 transition-opacity duration-300"
                />
            </div>
        </div>
    );
}
